import { PromptExample } from '../components/CareerCopilotChat/CareerCopilotChat.types';

export const extractUrlFromString = (text: string) => {
  var urlRegex =
    /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
  return text?.match(urlRegex);
};

export function extractBaseUrl(urlString: string) {
  const url = new URL(urlString);
  const baseUrl = url.hostname.split('.')[0];

  return baseUrl;
}

const promptExamples = [
  'Summarize responsibilities for my current role',
  'Summarize differences between <role1> and <role2>',
  'List skills required for <role, discipline or profession>',
  'What are the benefits of Role Library?',
  'How can I grow in my career?',
];

export const getPromptExamples = () => {
  var examples = promptExamples;

  return examples.map((prompt, mapIndex) => {
    var index = prompt.indexOf('<');
    var entities = [];
    var promptToDisplay = prompt;
    while (index >= 0) {
      var word = promptToDisplay.substring(index, promptToDisplay.indexOf('>', index) + 1);
      var taxonomyTypeId = getTaxonomyTypeIdFromWord(word);
      var entity = {
        id: index.toString(),
        cursorLocation: index,
        taxonomyTypeId: taxonomyTypeId,
      };
      entities.push(entity);
      promptToDisplay = promptToDisplay.replace(word, '/');
      index = promptToDisplay.indexOf('<', index + 1);
    }
    return {
      id: mapIndex.toString(),
      prompt: prompt,
      entities: entities,
      promptToDisplay: promptToDisplay,
    } as PromptExample;
  });
};

function getTaxonomyTypeIdFromWord(word: string) {
  var taxonomyTypeId = undefined;
  if (word.indexOf('role') >= 0 && word.indexOf('discipline') >= 0 && word.indexOf('profession') >= 0) {
    taxonomyTypeId = undefined;
  } else if (word.indexOf('role') >= 0) {
    taxonomyTypeId = 'role';
  } else if (word.indexOf('discipline') >= 0) {
    taxonomyTypeId = 'discipline';
  } else if (word.indexOf('profession') >= 0) {
    taxonomyTypeId = 'profession';
  }
  return taxonomyTypeId;
}
